@if ($branding.isBrandingUnavailable()) {
  <app-branding-unavailable />
} @else {
  <p-toast
    [showTransitionOptions]="'250ms'"
    [showTransformOptions]="'translateX(100%)'"
    [hideTransitionOptions]="'150ms'"
    [hideTransformOptions]="'translateX(100%)'"
  />
  <p-blockUI [blocked]="spinner.isLoading()">
    @if (spinner.isLoading()) {
      <p-progressSpinner strokeWidth="5" class="full-spinner my-auto"> </p-progressSpinner>
    }
  </p-blockUI>
  <router-outlet />
}
